export const sharedEnvironment = {
  USERS_API_URL: 'https://apis.manhattanprep.com/v1/users',
  ATLAS_URL: 'https://www.manhattanprep.com/atlas',
  BASE_DOMAIN: 'https://www.manhattanprep.com',
  REDIRECT_URL_PROGRAM_ID_QUERYPARAM: 'cckpgid',
  REDIRECT_URL_CLIENT_ID_QUERYPARAM: 'client_id',
  KAP_GTM_ID: 'GTM-TL43PH8',
  PROGRAM_ID_TESTLINE_MAP: {
    193: 'lsat',
    196: 'gre',
    203: 'gmat',
    245: 'gmat'
  }
}
